import cx from "classnames";
import { forwardRef, Ref } from "react";
import camelCase from "lodash-es/camelCase";

import { IconComponent } from "types/Icon";

import styles from "./styles.module.css";
import { IconColors } from "./types";

export type IconProps = React.SVGProps<SVGSVGElement> & {
  src: IconComponent;
  size?: "default" | "large" | "x-large" | "xx-large" | "stretch";
  rotate?: "90" | "180" | "270";
  withTransition?: boolean;
  color?: IconColors;
  noShrink?: boolean;
};

const Icon = forwardRef(function Icon(
  {
    src: IconSVG,
    size = "default",
    className,
    rotate,
    color,
    noShrink,
    withTransition,
    ...rest
  }: IconProps,
  ref: React.ForwardedRef<HTMLElement>
) {
  return (
    <IconSVG
      ref={ref as Ref<SVGSVGElement>}
      className={cx(
        styles.icon,
        styles[camelCase(size)],
        rotate && styles[`rotate${rotate}`],
        noShrink && styles.noShrink,
        color && styles[camelCase(`iconColor-${color}`)],
        withTransition && styles.withTransition,
        className
      )}
      aria-hidden
      {...rest}
    />
  );
});

Icon.displayName = "DS.Icon";

export default Icon;
